<template>
  <BThead>
    <BTr>
      <BTh
        :class="defaultThClass"
        class="min-w-[30px]"
      >
        <b-checkbox
          :checked="isCheckedAll"
          :disabled="isDisabled"
          :indeterminate="isIndeterminate"
          :class="{
            '[&_.custom-control-label::before]:!bg-[#E2E2E2] [&_.custom-control-label::after]:brightness-50': isDisabled,
          }"
          @change="handleToggleSelect"
        />
      </BTh>
      <BTh
        :class="defaultThClass"
        class="min-w-[270px]"
      >
        Nama Produk
      </BTh>
      <BTh
        :class="defaultThClass"
        class="min-w-[250px]"
      >
        Variasi
      </BTh>
      <BTh
        :class="defaultThClass"
        class="min-w-[160px]"
      >
        Jumlah Item
      </BTh>
      <BTh
        :class="defaultThClass"
        class="min-w-[160px]"
      >
        Jumlah Order
      </BTh>
      <BTh
        :class="defaultThClass"
        class="min-w-[200px]"
      >
        Status
      </BTh>
      <BTh
        :class="defaultThClass"
        class="min-w-[200px]"
      >
        Bahan Packing
      </BTh>
    </BTr>
  </BThead>
</template>

<script>
import { defaultThClass } from '../../../config'

export default {
  name: 'TableHeader',
  props: {
    isCheckedAll: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isIndeterminate: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    defaultThClass() {
      return defaultThClass
    },
  },
  methods: {
    handleToggleSelect(value) {
      this.$emit('toggle-select', value)
    },
  },
}
</script>
